import { brandColors } from '@src/assets/colors/brandColors';
import SvgIconStrike from '@src/assets/images/common/icon/editor/SvgIconStrike';
import type { Editor } from '@tiptap/react';
import React from 'react';

interface StrikeButtonProps {
  editor: Editor;
  isActive: boolean;
  refreshActiveState: () => void;
}

export const StrikeButton: React.FC<StrikeButtonProps> = ({
  editor,
  isActive,
  refreshActiveState,
}) => {
  const activeHoverColor = brandColors['500'] || '#2B5CDD';
  const defaultIconColor = 'currentColor';

  return (
    <button
      onClick={() => {
        editor.view.dom.focus({ preventScroll: true });
        editor.chain().toggleStrike().run();
        refreshActiveState();
      }}
      className={`toolbar-button ${isActive ? 'active' : ''}`}
      title='取り消し線'
      type='button'
    >
      <SvgIconStrike color={isActive ? activeHoverColor : defaultIconColor} />
    </button>
  );
};
